<template>
  <v-container class="feature-container">
    <v-row align="center">
      <v-col align="center" cols="12" lg="12" md="12" sm="12" xs="12">
        <h1>{{ this.lg_footer.information_technology_security_policy }}</h1>
      </v-col>
    </v-row>

    <v-row v-if="checklanguage === 'th'" align="center" justify="center" >
      <v-col  cols="12" xl="6" lg="8" md="8" sm="8" xs="10" v-bind:style="{height:'60vh', overflow:'auto' }">
          <span style="font-size:16px;" v-html="`
        <h3><span style='font-weight:bold;'>ความมุ่งมั่นด้านความปลอดภัยของ Dmeets </span></h3> 
          <span >บริษัท ดิจิทัล คอร์ปอเรท เมเนจเม้นท์ จำกัด (“DCM”)
ให้ความสำคัญสูงสุดในการรักษาความมั่นคงปลอดภัยของข้อมูล สำหรับผู้ใช้งานระบบ Dmeets
การประชุมออนไลน์และการลงคะแนนเสียงผ่านสื่ออิเล็กทรอนิกส์ นโยบายนี้สะท้อนถึงความมุ่งมั่นของบริษัท
ในการรักษาความลับ ความถูกต้องครบถ้วน และความพร้อมใช้งานของข้อมูล ตลอดจนปฏิบัติตาม พ.ร.บ.
คุ้มครองข้อมูลส่วนบุคคล (PDPA) และมาตรฐานสากลเช่น ISO/IEC 27001 </span>  
  <br><br><h3><span style='font-weight:bold;'>หลักการสําคัญด้านความปลอดภัย </span></h3> 
  <ul>
    <li>
      <span>การรักษาความลับของข้อมูล: บริษัทจัดประเภทความลับของข้อมูลและจํากัดการเข้าถึงเฉพาะผู้มีสิทธิ
      ข้อมูลส่วนบุคคลจะไม่ถูกเปิดเผยโดยไม่ได้รับอนุญาต </span>
    </li>
    <br>
    <li>
      <span>การควบคุมการเข้าถึง: ผู้ใช้งานต้องผ่านการยืนยันตัวตน และได้รับสิทธิในการเข้าถึงตามหน้าที่เท่านั้น พร้อมมีการใช้ VPN และมาตรฐานการเข้ารหัส </span>
    </li>
    <br>
    <li>
      <span>การเข้ารหัสข้อมูล: ข้อมูลทั้งหมดจะถูกเข้ารหัสทั้งขณะจัดเก็บ (Data-at-rest) และขณะส่งผ่านระบบ (Data-in-transit) ด้วยมาตรฐานที่ยอมรับทั่วโลก </span>
    </li>
    <br>
     <li>
      <span>การรักษาความปลอดภัยเชิงกายภาพ: พื้นที่ระบบสําคัญถูกควบคุมทางกายภาพ และมีระบบตรวจสอบการเข้า-ออก </span>
    </li>
    <br>
     <li>
      <span>การตอบสนองเหตุการณ์: บริษัทมีขั้นตอนตรวจจับ ตอบสนอง และฟื้นฟูจากเหตุการณ์ด้านความปลอดภัย </span>
    </li>
    <br>
     <li>
      <span>การบันทึกและตรวจสอบ: ระบบจะมีการบันทึกกิจกรรมต่าง ๆ อย่างครบถ้วน เช่น การเข้าสู่ระบบ การพยายามเข้าถึงระบบผิดปกติ และเก็บรักษาอย่างน้อย 90 วัน </span>
    </li>
    <br>
     <li>
      <span>การฝึกอบรมและความร่วมมือ: พนักงานและผู้รับจ้างทุกคนต้องลงนามในข้อตกลงรักษาความลับและเข้ารับการอบรมเรื่องความปลอดภัยเป็นประจํา </span>
    </li>
     <br>
  </ul>
          <br><span>บริษัทฯ มีการทบทวนนโยบายด้านความมั่นคงปลอดภัยอย่างสม่ําเสมอ </span>
          <br><br><span>เพื่อให้สอดคล้องกับภัยคุกคามที่เปลี่ยนแปลงและรักษาความมั่นใจให้แก่ผู้ใช้งานทุกคน </span>

 <br><span style='font-weight:bold;'>📧 ติดต่อสอบถาม: contact@dcm.co.th | ☎ โทร: 02-233-0055</span>
          `">
        </span>
      
      </v-col>
    </v-row>

     <v-row v-else align="center" justify="center" >
      <v-col  cols="12" xl="6" lg="8" md="8" sm="8" xs="10" v-bind:style="{height:'60vh', overflow:'auto' }">
        <span style="font-size:16px;" v-html="`
        <h3><span style='font-weight:bold;'>Dmeets Information Security Commitment </span></h3> 
          <span >At Digital Corporate Management Co., Ltd. (“DCM”), we are committed to maintaining
the highest standards of information security for all users of the Dmeets E-Meeting and
E-Voting Platform. This policy reflects our dedication to protecting confidentiality,
integrity, and availability of meeting data and personal information in full compliance
with the Personal Data Protection Act (PDPA) and international standards such as
ISO/IEC 27001. </span>  
  <br><br><h3><span style='font-weight:bold;'>Key Security Principles: </span></h3> 
  <ul>
    <li>
      <span>Data Confidentiality: All personal and meeting-related data are protected by strict
      access control and data classification standards. Sensitive information is never shared
      without authorization. </span>
    </li>
    <br>
    <li>
      <span>Secure Access: All users are authenticated with secure credentials and granted only
      necessary access rights. VPN and encryption protocols are enforced. </span>
    </li>
    <br>
    <li>
      <span>Encryption & Protection: Data is encrypted both at rest and during transmission using
      industry-standard methods (e.g., HTTPS/SSL). </span>
    </li>
    <br>
     <li>
      <span>Physical & Environmental Controls: Access to critical systems and server areas is
      physically restricted and monitored. </span>
    </li>
    <br>
     <li>
      <span>Incident Response & Business Continuity: We maintain robust procedures to detect,
      respond to, and recover from security incidents and service disruptions. </span>
    </li>
    <br>
     <li>
      <span>Monitoring & Audit: System activity, login attempts, and electronic transactions are
      logged and retained for at least 90 days. </span>
    </li>
    <br>
     <li>
      <span>Compliance & Training: All staff and third parties are required to sign confidentiality
      agreements and receive regular security training. </span>
    </li>
     <br>
  </ul>
          <br><span>DCM conducts regular reviews of our information security policies to adapt to evolving
risks and ensure ongoing protection for our customers. </span>
          <br><br><span>For inquiries, please contact: </span>

 <br><span style='font-weight:bold;'>📧 contact@dcm.co.th | ☎ +66 (0) 2233 0055</span>
          `">
        </span>
      
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { feature } from "../services/constants.js";
import { lg_footer } from "./language/lg_footer.js";
export default {
  name: "feature",
  data: () => ({
    width: 420,
    text_fontsize: 30,
    checklanguage:"",
  }),
  methods: {
    onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
  },
  async mounted() {
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;

    // alert(localStorage.getItem("language"))
    // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_footer = lg_footer.lg_footer_th)
      : (this.lg_footer = lg_footer.lg_footer_en);

    // console.log("lg_login: " + JSON.stringify(this.lg_login));
  },
};
</script>

<style>
@media (min-width: 960px) {
  .feature-container {
    margin-top: 3rem
  }
}
</style>
